/**
 * HUB-H — Carte alerte anti-fraude.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { FRAUD_SEVERITY_META } from '../../utils/equipe/equipeDisplay';

export default function ActiviteEquipeAlertCard({ alert, testIdPrefix = 'activite-equipe' }) {
  const sev = FRAUD_SEVERITY_META[alert.severity] || FRAUD_SEVERITY_META.warning;

  return (
    <article
      className="rounded-xl border p-4"
      style={{ borderColor: 'var(--rm-border-subtle)', background: 'var(--rm-bg-panel)' }}
      data-testid={`${testIdPrefix}-alert-${alert.type}-${alert.username || alert.reference || 'x'}`}
    >
      <div className="flex flex-wrap items-start justify-between gap-2 mb-2">
        <p className="font-semibold text-[var(--rm-white)] text-sm flex-1 min-w-0">{alert.message}</p>
        <span className={sev.badge}>{sev.label}</span>
      </div>
      <div className="flex flex-wrap items-center justify-between gap-2 text-sm">
        <span className="text-[var(--rm-gray-400)]">
          {alert.username || alert.reference || '—'}
          {alert.count != null ? ` · ${alert.count} occurrence(s)` : ''}
        </span>
        <Link
          to="/admin/audit"
          className="text-xs text-[var(--rm-gray-400)] hover:text-[var(--rm-white)] inline-flex items-center gap-1 min-h-[44px] px-2"
          data-testid={`${testIdPrefix}-alert-link-${alert.type}`}
        >
          Voir audit
          <ArrowRight className="w-3 h-3" />
        </Link>
      </div>
    </article>
  );
}
